const getUrlParam = p => {
  if (typeof window === "undefined") return ""
  var match = RegExp("[?&]" + p + "=([^&]*)").exec(window.location.search)
  return match && decodeURIComponent(match[1].replace(/\+/g, " "))
}

export default getUrlParam
